import { render, staticRenderFns } from "./JobContentStatus.vue?vue&type=template&id=1059c70c"
import script from "./JobContentStatus.vue?vue&type=script&lang=js"
export * from "./JobContentStatus.vue?vue&type=script&lang=js"
import style0 from "./JobContentStatus.vue?vue&type=style&index=0&id=1059c70c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports